import scroller from '../scroller';

const destroyAnimeblick = (parent) => {
	let $glare = parent.querySelector('.chapter-glare');

	if ($glare) {
		gsap.killTweensOf($glare);
	}
};

const initAnimeblick = (parent) => {
	let $glare = parent.querySelector('.chapter-glare');

	if ($glare === null) {
		return;
	}

	function makeNewPosition() {
		let h = $(parent).height() / 3 - 50;
		let w = $(parent).width() / 1.5 - 50;

		let nh = Math.floor(Math.random() * h);
		let nw = Math.floor(Math.random() * w);

		return [nh, nw];
	}

	function animateDiv() {
		const position = makeNewPosition();

		gsap.to($glare, {
			onComplete: animateDiv,
			duration: 2,
			ease: 'linear',
			x: position[1],
			y: position[0],
		});
	}

	animateDiv();
};

const fixedHighlight = (parent) => {
	const $glare = parent.querySelector('.chapter-glare');

	if ($glare) {
		ScrollTrigger.create({
			trigger: $glare,
			start: 'top top',
			endTrigger: parent,
			end: 'bottom+=100vh bottom',
			pin: true,
			pinType: 'transform',
			pinReparent: false,
			pinSpacing: true,
			// markers: {
			// 	startColor: 'green',
			// 	endColor: 'green',
			// },
			scroller: scroller.getElement(),
		});
	}
};
const animateHighlight = (parent, fixed = true) => {
	if (fixed) {
		fixedHighlight(parent);
	}

	ScrollTrigger.create({
		onEnter() {
			initAnimeblick(parent);
		},
		onEnterBack() {
			initAnimeblick(parent);
		},
		onLeave() {
			destroyAnimeblick(parent);
		},
		onLeaveBack() {
			destroyAnimeblick(parent);
		},
		trigger: parent,
		start: 'top 50%',
		end: 'bottom+=50 bottom',
		// markers: {
		// 	startColor: 'red',
		// 	endColor: 'red',
		// },
		scroller: scroller.getElement(),
	});
};

const animateGradient = (parent) => {
	const pl = parent.querySelector('.chapter-container--gradient-light');

	ScrollTrigger.create({
		trigger: pl,
		start: 'top top',
		endTrigger: parent,
		end: 'bottom+=100vh bottom',
		pin: true,
		pinType: 'transform',
		pinReparent: false,
		pinSpacing: true,
		scroller: scroller.getElement(),
	});
};

export {animateHighlight, animateGradient, fixedHighlight};
